import axios from 'axios'

export const HTTP = axios.create({
    // baseURL: 'http://dev.yugpartner.com.ua/api/',
    baseURL: 'https://yugpartner.com.ua/api/',
    headers: {  }
})

